.container {
  min-height: 100vh;
  background-color: #F7F9FC;
}

.header {
  background-color: #635BFF;
  color: white;
  padding: 40px 0;
  margin-bottom: 30px;
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}

.headerContent {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.headerRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.logoContainer {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.restaurantDescription {
  font-size: 16px;
  opacity: 0.8;
}

.secondaryButton {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.secondaryButton:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px 40px;
}

.qrFormSection {
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.qrFormSection h2 {
  margin-top: 0;
  color: #2D3748;
}

.formGroup {
  margin-bottom: 20px;
}

.formGroup label {
  display: block;
  font-weight: 500;
  margin-bottom: 6px;
}

.input {
  width: 100%;
  padding: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 16px;
}

.helpText {
  font-size: 14px;
  color: #718096;
  margin-top: 6px;
}

.qrCodeSection {
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
}

.qrCodeWrapper {
  display: inline-block;
  padding: 20px;
  background-color: white;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  margin-bottom: 16px;
}

.qrCode {
  max-width: 250px;
}

.qrInfo {
  margin-top: 12px;
  text-align: left;
}

.downloadButton {
  background-color: #635BFF;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 20px;
}

.downloadButton:hover {
  background-color: #524ddb;
}

.instructions {
  text-align: left;
  margin-top: 30px;
  border-top: 1px solid #E2E8F0;
  padding-top: 20px;
}

.instructions h3 {
  margin-top: 0;
  color: #2D3748;
}

.instructions ol {
  padding-left: 20px;
}

.instructions li {
  margin-bottom: 8px;
}

.loadingContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #4A5568;
}

.loadingSpinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border-left-color: #635BFF;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .headerRow {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .secondaryButton {
    margin-left: auto;
  }
}